import type { Dictionary } from './core.js';

/** Slovak is the reference dictionary: every other locale must match its keys. */
export const sk: Dictionary = {
  'app.title': 'Duren',
  'app.cardsCredit':
    'Karty: SVG Playing Cards od Daniela S. Fowlera (tekeye.uk), CC0 / public domain.',

  'mode.local': 'Na tomto zariadení',
  'mode.online': 'Online izba',
  'mode.localLede': 'Hra proti botom alebo proti sebe na jednom zariadení.',
  'mode.onlineLede': 'Hra so živými hráčmi. Vytvor izbu a pošli kód — netreba účet ani inštaláciu.',

  'conn.online': 'pripojené',
  'conn.connecting': 'pripájam sa…',
  'conn.offline': 'odpojené',

  'field.players': 'Hráčov',
  'field.deck': 'Balík',
  'field.seed': 'Seed',
  'field.seedHint': 'Rovnaký seed rozdá rovnaké karty — hra je plne reprodukovateľná.',
  'field.name': 'Tvoje meno',
  'field.roomCode': 'Kód izby',
  'field.seat': 'Miesto {n}',
  'player.seat': 'Hráč {n}',
  'field.language': 'Jazyk',
  'deck.36': '36 kariet',
  'deck.52': '52 kariet',
  'seat.human': 'Človek',
  'seat.soon': ' (čoskoro)',

  'action.newGame': 'Nová hra',
  'action.undo': 'Späť',
  'action.createRoom': 'Vytvoriť izbu',
  'action.join': 'Pripojiť sa',
  'action.start': 'Začať hru',
  'action.rematch': 'Odveta',
  'action.leave': 'Opustiť izbu',
  'action.copyLink': 'Kopírovať odkaz',
  'action.copied': 'Skopírované',
  'action.sitHere': 'Sadnúť si sem',
  'action.removeBot': 'Odobrať',
  'action.send': 'Poslať',
  'action.take': 'Beriem',
  'action.pass': 'Bito / koniec prihadzovania',
  'action.transfer': 'Prehodiť {card}',
  'action.transferReveal': 'Prehodiť {card} (ukázať)',
  'action.switchTo': 'Prepnúť na {name}',

  'board.trump': 'Tromf',
  'board.trumpIs': 'Tromf: {suit}',
  'board.bout': 'Kolo {n}',
  'board.deck': 'Balík {n}',
  'board.discard': 'Odhodené {n}',
  'board.deckEmpty': 'Balík je prázdny',
  'board.table': 'Stôl',
  'board.trumpCard': 'Tromfová karta na spodku balíka',
  'board.attacks': '{name} útočí.',
  'board.gameOver': 'Hra skončila.',
  'board.unbeatenHint': 'Nezbité — klikni pre voľbu cieľa obrany',
  'board.noCards': 'bez kariet',
  'board.switchHint': 'Prepnúť na tohto hráča',
  'board.notYours': 'Za toto miesto teraz nehráš',
  'board.manyActors': 'Konať môže viacero hráčov naraz.',
  'board.waiting': 'Čaká sa na ostatných…',
  'board.cards': { one: '{count} karta', few: '{count} karty', other: '{count} kariet' },

  'settings.title': 'Nastavenia hry',
  'settings.botSpeed': 'Pauza botov',
  'settings.botSpeed.hint': 'Ako dlho bot počká, kým položí kartu. Nula znamená okamžite.',
  'settings.seconds': '{n} s',
  'settings.holdForThrowIn': 'Počkať na mňa, keď môžem prihodiť',
  'settings.holdForThrowIn.hint': 'Boti sa zastavia, kým nezahráš alebo nestlačíš „Bito“. Bez toho ti môže niekto prihodiť skôr, než si to vôbec všimneš.',
  'settings.showLog': 'Zobraziť prepis hry',
  'settings.showLog.hint': 'Bočný stĺpec s tým, kto čo položil.',
  'board.yourThrowIn': 'Môžeš prihodiť — zahraj kartu alebo stlač „Bito“.',
  'settings.showStatus': 'Zobraziť údaje o hre',
  'settings.showStatus.hint': 'Tromf, kolo, zvyšok balíka a odhodené — nad tvojimi kartami.',
  'setup.title': 'Nastavenia a nová hra',
  'card.back': 'Rubová strana',
  'card.deckOf': 'Balík má {count} kariet',

  'role.bot': 'bot',
  'role.away': 'odpojený',
  'role.substituted': 'hrá zaň bot',
  'role.attacks': 'útočí',
  'role.defends': 'bráni',
  'role.takes': 'berie',
  'role.out': 'vypadol z hry',
  'role.passed': 'pasoval',

  'suit.clubs': 'Kríže',
  'suit.diamonds': 'Kára',
  'suit.hearts': 'Srdcia',
  'suit.spades': 'Piky',

  'banner.stalemate': 'Patová pozícia — karty len kolovali dokola, nikto nie je duren.',
  'banner.draw': 'Remíza — všetci sa zbavili kariet naraz.',
  'rules.teams': 'Tímy 2v2',
  'rules.teams.hint': 'Štyria hráči, dvojice oproti sebe. Spoluhráči na seba neútočia ani neprehadzujú.',
  'team.name': 'Tím {n}',
  'banner.teamLost': 'Prehráva {team}.',
  'banner.durak': 'Duren je {name}.',

  'log.title': 'Priebeh',
  'log.dealt': 'Rozdané. Tromfová karta: {card}.',
  'log.attack': '{name} útočí {card}.',
  'log.throwIn': '{name} prihadzuje {card}.',
  'log.defend': '{name} zbíja kartou {card}.',
  'log.transfer': '{name} prehadzuje {card} na {target}.',
  'log.transferReveal': '{name} ukazuje {card} a prehadzuje útok na {target}.',
  'log.takeDeclared': '{name} berie.',
  'log.take': '{name} si berie {cards}.',
  'log.pass': '{name} pasuje.',
  'log.bito': 'Bito: {cards}.',
  'log.draw': '{name} dobral {count} kariet.',
  'log.trumpTaken': '{name} berie tromfovú kartu {card} — balík je prázdny.',
  'log.out': '{name} sa zbavil kariet.',
  'log.stalemate': 'Patová pozícia — hra sa už nikam neposúvala.',
  'log.drawGame': 'Remíza — nikto nie je duren.',
  'log.durak': 'Duren: {name}.',

  'bots.hint.none': 'Všetky miesta hrajú ľudia na jednom zariadení.',
  'bots.1.name': 'Začiatočník',
  'bots.1.blurb': 'Hrá najlacnejšiu možnú kartu a šetrí tromfy. Nepamätá si nič.',
  'bots.2.name': 'Pokročilý',
  'bots.2.blurb': 'Sleduje fázu hry, hospodári s tromfami a váži, či sa oplatí brať.',
  'bots.3.name': 'Počtár',
  'bots.3.blurb': 'Počíta odhodené karty a odhaduje, čo môže súper zbiť.',
  'bots.4.name': 'Majster',
  'bots.4.blurb': 'Modeluje súperovu ruku a cielene blafuje.',

  'lobby.room': 'Izba',
  'lobby.shareHint': 'Pošli tento kód alebo odkaz komukoľvek, kto sa má pridať. Netreba registráciu.',
  'lobby.host': 'hostiteľ',
  'lobby.you': 'ty',
  'lobby.rulesByHost': 'Pravidlá nastavuje hostiteľ.',
  'lobby.startByHost': 'Hru spúšťa hostiteľ.',
  'lobby.chatPlaceholder': 'Napíš niečo…',
  'lobby.chatLabel': 'Správa do chatu',
  'lobby.addBot': '+ {name}',

  'rules.title': 'Pravidlá',
  'rules.custom': 'vlastné nastavenie',
  'rules.scope': 'Kto smie prihadzovať',
  'rules.scope.all': 'Ktokoľvek',
  'rules.scope.neighbours': 'Len susedia obrancu',
  'rules.cap': 'Limit útoku',
  'rules.cap.defenderHand': 'Podľa ruky obrancu',
  'rules.cap.unlimited': 'Bez limitu',
  'rules.cap.fixed4': 'Najviac 4 karty',
  'rules.cap.fixed6': 'Najviac 6 kariet',
  'rules.afterTake': 'Prihadzovanie po „beriem"',
  'rules.afterTake.sameAsAttack': 'Rovnaký limit ako útok',
  'rules.afterTake.defenderHandAtBoutStart': 'Podľa ruky na začiatku kola',
  'rules.afterTake.unlimited': 'Až po strop stola',
  'rules.firstAttacker': 'Kto začína',
  'rules.firstAttacker.lowestTrump': 'Najnižší tromf',
  'rules.firstAttacker.random': 'Náhodne',
  'rules.transfer': 'Prehadzovanie (perevodnoy)',
  'rules.transfer.hint': 'Obranca môže útok posunúť ďalej kartou rovnakej hodnoty.',
  'rules.chains': 'Reťazenie prehodení',
  'rules.chains.hint': 'Aj nový obranca smie prehodiť ďalej.',
  'rules.reveal': 'Prehodenie ukázaním tromfu',
  'rules.reveal.hint': 'Tromf rovnakej hodnoty stačí ukázať, zostáva v ruke.',
  'rules.mustBeat': 'Obranca musí zbiť, ak môže',
  'rules.mustBeat.hint': 'Brať sa dá až keď naozaj niet čím zbiť. Mení hru viac, než sa zdá.',
  'rules.throwInAfterTake': 'Prihadzovať aj po „beriem"',
  'rules.firstBoutCap': 'Prvé kolo obmedzené',
  'rules.firstBoutCap.hint':
    'Prvý útok v hre smie mať najviac o kartu menej, než je veľkosť ruky.',
  'rules.trumpVisible': 'Tromfová karta viditeľná',
  'rules.trumpVisible.hint': 'Spodná karta balíka leží lícom hore.',

  'preset.classic': 'Klasický duren',
  'preset.classic.blurb': '36 kariet, prihadzuje ktokoľvek, obranca môže kedykoľvek vziať.',
  'preset.perevodnoy': 'S prehadzovaním',
  'preset.perevodnoy.blurb':
    'Obranca môže útok prehodiť na ďalšieho hráča kartou rovnakej hodnoty.',
  'preset.strict': 'Prísny',
  'preset.strict.blurb': 'Brať sa dá len keď naozaj niet čím zbiť, prvé kolo je obmedzené.',
  'preset.big': 'Veľký stôl',
  'preset.teams': 'Tímy 2v2',
  'preset.teams.blurb': 'Štyria hráči, dvojice sedia oproti sebe. Spoluhráč na teba nikdy neútočí.',
  'preset.big.blurb': '52 kariet pre 5–6 hráčov, útočia len susedia obrancu.',

  'problem.deck_too_small':
    '{deckSize} kariet nestačí pre {players} hráčov — treba aspoň {needed}, aby zostala tromfová karta.',
  'problem.deck_barely_sufficient':
    'Po rozdaní zostane v balíku veľmi málo kariet, koncovka príde takmer hneď.',
  'problem.players_out_of_range': 'Počet hráčov musí byť {min} až {max}.',
  'problem.hand_size_out_of_range': 'Nepodporovaná veľkosť ruky.',
  'problem.max_table_slots_out_of_range': 'Nepodporovaný limit kariet na stole.',
  'problem.first_bout_cap_meaningless': 'Obmedzenie prvého kola nedáva pri takto malej ruke zmysel.',
  'problem.attack_cap_out_of_range': 'Nepodporovaný limit útoku.',
  'problem.scope_has_no_effect':
    'Pri tomto počte hráčov je obrancov sused každý — voľba nič nemení.',
  'problem.transfer_options_without_transfer':
    'Podvoľby prehadzovania nič nerobia, kým je samotné prehadzovanie vypnuté.',
  'problem.transfer_two_players':
    'Vo dvojici sa útok prehodením vracia späť na útočníka — hra je tým divokejšia.',
  'problem.must_beat_all_changes_the_game':
    'Pravidlo „musí zbiť" berie obrancovi voľbu a výrazne pomáha počítajúcim botom.',
  'problem.must_beat_all_with_unlimited_pile':
    'S neobmedzeným prihadzovaním po „beriem" môžu útočníci obrancu mlieť celú ruku.',
  'problem.teams_need_four': 'Tímy 2v2 sa hrajú presne v štyroch, teraz je vás {players}.',
  'problem.scope_ignored_in_teams': 'V tímoch sú susedmi obrancu práve obaja súperi — voľba nič nemení.',
  'problem.not_enough_players': 'Na hru treba aspoň dvoch — pridaj hráča alebo bota.',

  'error.room_not_found': 'Izba s týmto kódom neexistuje. Skontroluj kód.',
  'error.room_full': 'Izba je plná.',
  'error.room_in_progress': 'V izbe už beží hra.',
  'error.not_host': 'Toto môže zmeniť len hostiteľ.',
  'error.not_enough_players': 'Na hru treba aspoň dvoch hráčov.',
  'error.server_full': 'Server je momentálne plný, skús to o chvíľu.',
  'error.seat_taken': 'Toto miesto je už obsadené.',
  'error.rate_limited': 'Priveľa akcií naraz, spomaľ trochu.',
  'error.illegal_move': 'Tento ťah nie je podľa pravidiel.',
  'error.protocol_mismatch': 'Stránka je zastaraná — obnov ju (Ctrl+R).',
  'error.unknown': 'Chyba: {code}',

  // --- table design (skins, chairs, waiting room) ---
  'role.idle': 'čaká',
  'turn.you.attack': 'Ty · útočíš',
  'turn.you.defend': 'Ty · brániš sa',
  'turn.you.act': 'Ty · si na ťahu',
  'settings.appearance': 'Vzhľad',
  'settings.skin': 'Grafický štýl',
  'settings.theme': 'Denný / nočný režim',
  'skin.organic': 'Organic',
  'skin.modern': 'Modern',
  'skin.classic': 'Klasik',
  'theme.light': 'Denný',
  'theme.dark': 'Nočný',
  'entry.kicker': 'Vitaj pri stole',
  'entry.title': 'Zahraj si duren.',
  'entry.botsKicker': 'Súperi',
  'entry.botsTitle': 'Boti, ktorých môžeš posadiť k stolu',
  'lobby.waitingTitle': 'Čakáme na hráčov',
  'lobby.seatsFilled': '{n} zo {max} miest obsadených',
  'lobby.chat': 'Chat',
  'lobby.facts': 'Nastavenia stola',
  'lobby.invite': 'Pozvať',
  'lobby.seated': 'Sedí',
  'lobby.free': 'Voľné miesto',
  'lobby.freeHint': 'čaká na hráča alebo bota',
  'lobby.player': 'hráč',
  'lobby.fact.seats': 'Obsadenosť',
  'lobby.fact.code': 'Kód izby',
  'yes': 'áno',
  'no': 'nie',

  // --- decks, sorting, hints ---
  'settings.cardTheme': 'Balíček kariet',
  'cards.classic': 'Klasické',
  'cards.minimal': 'Minimal',
  'settings.sortBy': 'Zoradiť karty',
  'sort.suit': 'Podľa farby',
  'sort.power': 'Podľa sily',
  'settings.hints': 'Nápoveda ťahu',
  'settings.hints.hint': 'Stmaví karty, ktoré teraz nemôžeš zahrať. Vypnuté vyzerá ruka rovnako a musíš si to ustrážiť sám.',
  'role.canThrowIn': 'môže prihodiť',
};
